module.exports = __webpack_public_path__ + "img/module1.f3665e6d.png";